module.exports = __webpack_public_path__ + "static/media/computer-pc-workplace-home-office-159760.cbdc5111.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/004_mi/computer-pc-workplace-home-office-159760.jpeg
// module id = 771
// module chunks = 0